<template>
  <div class="view view-forgot-password">
    <div class="view-forgot-password__form-container">
      <Logo src="/graphics/logo-dark.png"></Logo>
      <div class="view-forgot-password__message-container" v-if="messages && messages.length">
        <div v-for="(message, index) in messages" class="message" :key="index"
             :class="{ 'message-error': message.type === 'error', 'message-success': message.type === 'success' }">
          {{ message.text }}
        </div>
      </div>
      <form @submit.prevent="handleSubmit" class="view-forgot-password__form">
        <div class="form-field">
          <input class="" type="email" name="email" v-model="email" placeholder="E-Mail" required
                 :disabled="isLoading || isSubmitted">
          <span class="form-forgot-password__message"></span>
        </div>
        <button type="submit" class="btn btn--red" :disabled="isLoading || isSubmitted">Passwort zurücksetzen</button>
        <LoadingAnimation v-if="isLoading"></LoadingAnimation>
      </form>
      <div class="view-forgot-password__footer">
        <router-link
            to="/login"
            class="view-forgot-password__footer__link"
            v-if="!isLoading"
        >Zurück zur Anmeldung
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue"
import { storeToRefs } from "pinia"
import { useSessionStore, GeneralAuthError, InvalidCredentialsError } from "../stores/session"
import Logo from "../components/Logo"
import LoadingAnimation from "../components/LoadingAnimation"


export default defineComponent({
  components: { LoadingAnimation, Logo },
  setup() {
    const sessionStore = useSessionStore()
    const email = ref("")
    const messages = ref([])
    const { isLoading } = storeToRefs(sessionStore)
    let isSubmitted = false

    const handleSubmit = async () => {
      try {
        await sessionStore.resetPasswordByEmail(email.value)
        messages.value = [
          {
            type: "success",
            text: "Sie erhalten per E-Mail einen Link, mit dem Sie ein neues Passwort vergeben können. ✔",
          }]
        isSubmitted = true
      } catch (error) {
        if (error instanceof InvalidCredentialsError) {
          messages.value = [{
            type: "error",
            text: "Benutzer nicht gefunden. Bitte versuchen Sie es erneut.",
          }]
        } else {
          messages.value = [
            {
              type: "error",
              text: "Unbekannter Loginfehler. Bitte versuchen Sie es später nochmal.",
            }]
        }
      }
    }

    return { email, isLoading, messages, handleSubmit, isSubmitted }
  },
})
</script>

<style lang="scss" scoped>
@use '../style/util/responsiveness' as res;
@use '../style/components/form';

.view-forgot-password {
  display: flex;
  background-color: var(--color-lightest-gray);
  align-items: center;
  justify-content: center;

  &__form-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    margin: 0 auto;
    padding: 2rem 4rem 4rem;
    height: 100vh;
    width: 100%;
    color: var(--color-dark-gray);
    background-color: var(--color-white);
    box-sizing: border-box;


    @include res.from('tablet') {
      max-width: 480px;
      width: calc(100% - 8rem);
      height: auto;
      border-radius: 16px;
    }

    .logo {
      width: 100%;
      max-width: 380px;
      margin: -4rem auto 1rem;

      @include res.from('tablet') {
        margin: 2.5rem auto 1rem;
        width: 80%;
      }
    }
  }

  &__form {
    @extend .form;

    margin: 2rem 0;
  }

  &__footer {
    display: flex;
    justify-content: center;
    align-items: center;

    &__link {
      color: var(--color-gray);
      text-decoration: none;

      &:hover,
      &:focus {
        text-decoration: underline;
      }
    }
  }

  .btn {
    margin: 3rem auto 2rem;

    @include res.from('tablet') {
      margin: 3.5rem auto 4rem;
    }
  }

  &__message-container {
    margin: 2rem 0 0;
    text-align: center;

    @include res.from("tablet") {
      padding: 0 2rem;
    }
  }

  .message-error {
    color: var(--color-danger);
  }

  .message-success {
    color: var(--color-success);
  }

  .loading-container {
    color: var(--color-success);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 1rem;
  }
}

</style>
